import { lazy } from 'react';

// project imports
import MainLayout from 'views/components/layout/MainLayout';
import Loadable from 'views/components/ui-component/Loadable';
import { Navigate } from 'react-router';

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/components/ui-component/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/components/ui-component/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/components/ui-component/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/components/ui-component/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/components/ui-component/TablerIcons')));

// ==============================|| MAIN ROUTING ||============================== //

const NotFoundRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '*',
            element: <Navigate to="/" replace />
        }
    ]
};

export default NotFoundRoutes;
